module.exports = __webpack_public_path__ + "media/hph-23-12_commencement.9a4f82e0.mp4";